import type { GlobalFeedbackCollectorComponentProps } from '@confluence/global-feedback-collector/entry-points/GlobalFeedbackCollector.ts';

export type FeedbackModalProps = GlobalFeedbackCollectorComponentProps;
export type FeedbackHandler = (options: FeedbackModalProps) => Promise<void>;

export class ContentFeedbackService {
	#feedbackHandler: FeedbackHandler = async () => {};
	#closeHandler: () => void = () => {};

	registerFeedbackHandler(feedbackHandler: FeedbackHandler): void {
		this.#feedbackHandler = feedbackHandler;
	}

	registerCloseHandler(closeHandler: () => void): void {
		this.#closeHandler = closeHandler;
	}

	// Show Global Feedback Collector with provided options
	// Feedback handler returns deferred Promise that resolves when modal is closed
	showFeedbackCollector(options: FeedbackModalProps): Promise<void> {
		return this.#feedbackHandler(options);
	}

	// Method exposed to bridge API for allowing whiteboards to close feedback modal
	closeFeedbackModal(): void {
		this.#closeHandler();
	}
}

export const feedbackService: ContentFeedbackService = new ContentFeedbackService();
